<script>
  import { isEnglish, setIsEnglish } from "../stores/cookies.js";
  import InfoCard from "../components/InfoCard.svelte";
  import BottomCard from "../components/BottomCard.svelte";
  import AppBar from "../components/AppBar.svelte";
  import ImageCarousel from "../components/ImageCarousel.svelte";

  const imagesMain = [
    { src: "/assets/mainpageslidesactive/Image1.jpeg", alt: "Image One" },
    { src: "/assets/mainpageslidesactive/Image4.jpeg", alt: "Image Two" },
    { src: "/assets/mainpageslidesactive/Image7.jpeg", alt: "Image Three" },
    { src: "/assets/mainpageslidesactive/Image2.jpeg", alt: "Image Four" },
    { src: "/assets/mainpageslidesactive/Image5.jpeg", alt: "Image Five" },
    { src: "/assets/mainpageslidesactive/Image3.jpeg", alt: "Image Five" },
    { src: "/assets/mainpageslidesactive/Image8.jpeg", alt: "Image Six" },
  ];

  const imagesAbout = [
    { src: "/assets/mainpageslidesactive/Image1.jpeg", alt: "Image One" },
    { src: "/assets/mainpageslidesactive/Image6.jpeg", alt: "Image Two" },
    { src: "/assets/mainpageslidesactive/Image9.jpeg", alt: "Image Three" },
  ];
</script>

<AppBar />

<main class="p-4 mx-auto space-y-6">
  <ImageCarousel images={imagesMain} />

  {#if false}
    {#each [$isEnglish ? 'Enhancing the Health and Well-being of Your <span class="text-blue-600 font-semibold">Best Friend</span>!' : 'Verbeter die Gesondheid en Welstand van Jou <span class="text-blue-600 font-semibold">Beste Vriend</span>!', $isEnglish ? 'Providing a Full Range of <span class="text-blue-600 font-semibold">Comprehensive Medical Care and Services</span>!' : 'Ons Bied `n Vol Reeks <span class="text-blue-600 font-semibold">Omvattende Mediese Sorg en Dienste Aan</span>!', $isEnglish ? 'Herd Health Visits, <span class="text-blue-600 font-semibold">Including Pregnancy Scans and Artificial Inseminations</span>!' : 'Kudde Gesondheids Besoeke, <span class="text-blue-600 font-semibold">Insluitende Dragtigheids Ondersoeke, Sonars en Sinkronisasie asook KI</span>!', $isEnglish ? 'Full Mixed Practice, <span class="text-blue-600 font-semibold">Professional Veterinary Care for All Species</span>!' : 'Volledige Gemengde Dier Praktyk, <span class="text-blue-600 font-semibold">Professionele Veterinere Sorg vir Alle Diere</span>!'] as text, i}
      <div
        class={`flex w-full justify-center sm:justify-${i % 2 === 0 ? "start" : "end"}`}
      >
        <p
          class="bg-blue-50 text-blue-900 rounded-xl p-6 sm:p-8 text-2xl sm:text-4xl shadow-md max-w-[100%] sm:max-w-8xl"
        >
          {@html text}
        </p>
      </div>
    {/each}
  {/if}
  <div class="w-full h-[2px] bg-blue-600 my-10"></div>
  <!-- Cards grid container -->
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 justify-items-center mx-auto max-w-6xl"
  >
    <!-- Place your 6 (or fewer/more) cards here – they will flow naturally -->
    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/page1_ico1.png"
        title={$isEnglish ? "Small Animals" : "Klein Diere"}
        text={$isEnglish
          ? "We treat cats and dogs of all sizes, shapes and personalities. We are equipped with superb diagnostic capabilities, laboratory testing, profound veterinary surgery skills and emergency pet care."
          : "Ons behandel katte en honde van verskillende groottes, rasse en persoonlikhede. Ons is ten volle toegerus met al die nodige toerusting om diagnoses te doen, insluitende laboratoruim toetse. Ons het uitstekende veeartseny chirugiese vaardighede binne die praktyk, insluitende troeteldier noodgeval behandeling."}
        link="0"
      />
    </div>

    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/koei1.png"
        title={$isEnglish ? "Production Animals" : "Produksie Diere"}
        text={$isEnglish
          ? "We offer a comprehensive farm animal veterinary services, with wide expertise in disease prevention and control as well as a thorough and caring approach to individual animal medicine."
          : "Ons bied omvattende produksie dier veeartseny dienste aan, ons kundigheid sluit 'n wye verskeidenheid van siekte voorkoming en beheer behandelings in. Ons glo ook in 'n omgee benadering tot individuele diere se behandelings."}
        link="1"
      />
    </div>

    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/horse.png.png"
        title={$isEnglish ? "Equines" : "Perde"}
        text={$isEnglish
          ? "Weskus Veeartseny aims to offer professional, efficient and compassionate service to our clients and their horses."
          : "Weskus Veeartseny streef om profesionele, effektiewe dienste met deernis aan ons kliente en hul perde te bied."}
        link="2"
      />
    </div>

    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/afterHours.png"
        title={$isEnglish ? "After Hours" : "Na Ure"}
        text={$isEnglish
          ? "We provide a 24 hours <strong>emergency</strong> after hour care service. To get into contact with us after hours call us on"
          : "Ons bied 'n 24 uur <strong>noodgevalle</strong> na ure diens aan. Kontak ons na ure op"}
        number="063 112 8693"
      />
    </div>

    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/kudu.png"
        title={$isEnglish ? "Wildlife" : "Wild"}
        text={$isEnglish
          ? "We dart, capture and immobilise game."
          : "Ons skiet, pyl, vang en immobiliseer alle soorte wild."}
        link="3"
      />
    </div>

    <div class="pt-8 md:pt-8 lg:pt-8">
      <InfoCard
        image="/assets/icons/voel1.png.png"
        title={$isEnglish ? "Exotics" : "Eksotiese Diere"}
        text={$isEnglish
          ? "We provide medical and surgical veterinary care for a wide range of exotic animals."
          : "Ons bied mediese en chirurgiese veeartseny sorg aan vir 'n wye verskeidenheid eksotiese diere."}
        link="4"
      />
    </div>
  </div>

  <div class="w-full h-[2px] bg-blue-600 my-10"></div>

  <div
    class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12 space-y-10 md:space-y-12"
  >
    <!-- Heading – always centred at the top -->
    <h1
      class="text-center text-blue-900 font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight"
    >
      {$isEnglish ? "About Weskus Veeartseny" : "Meer Oor Weskus Veeartseny"}
    </h1>

    <!-- Image + Text section -->
    <div
      class="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-10 lg:gap-12"
    >
      <!-- Image – above on mobile, left on md+ -->
      <!-- <div class="flex-shrink-0">
        <img
          src="assets/logo/ingang1.jpg"
          alt={$isEnglish
            ? "Vredenburg Veterinary Hospital"
            : "Vredenburg Dierehospitaal"}
          class="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 object-cover rounded-2xl shadow-xl mx-auto md:mx-0"
        />
      </div> -->

      <div
        class="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 mx-auto md:mx-0 rounded-2xl shadow-xl overflow-hidden flex-shrink-0"
      >
        <ImageCarousel images={imagesAbout} compact />
      </div>

      <!-- Body text – below image on mobile, right of image on md+ -->
      <div class="text-center md:text-left max-w-3xl">
        <p class="text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed">
          {$isEnglish
            ? "We are a trusted veterinary group serving the West Coast through six practice locations across six towns."
            : "Ons is 'n betroubare veeartseny groep wat die Weskus bedien deur ses praktyke oor ses dorpe."}
        </p>

        <p
          class="mt-6 text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed"
        >
          {$isEnglish
            ? "Our network is built around two full-service hospitals in Vredenburg and Langebaan, supported by local clinics in Saldanha, Hopefield, St Helena Bay and Velddrif."
            : "Ons netwerk is gebou rondom twee volwaardige dierehospitale in Vredenburg en Langebaan, ondersteun deur plaaslike klinieke in Saldanha, Hopefield, St Helena Baai en Velddrif."}
        </p>

        <p
          class="mt-6 text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed"
        >
          {$isEnglish
            ? "Together, we provide convenient, high-quality care—whether you need a routine check-up close to home or more advanced treatment at one of our hospitals."
            : "Saam bied ons gerieflike, hoë kwaliteit sorg—of dit nou 'n roetine ondersoek naby jou huis is, of meer gevorderde behandeling by een van ons hospitale."}
        </p>
      </div>
    </div>
  </div>

  <div id="Locations">
    <BottomCard />
  </div>
</main>
